import { render } from "./AuthenticationCallback.vue?vue&type=template&id=b02662be&ts=true"
import script from "./AuthenticationCallback.vue?vue&type=script&lang=ts"
export * from "./AuthenticationCallback.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__